import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';

import {NgbActiveModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {AlertService, EventManager, JhiLanguageService} from 'ng-jhipster';

import {UserEchangeModalService} from './user-echange-modal.service';
import {JhiLanguageHelper} from '../../shared';
import {TypeEtudiantEnumeration, UserEnEchange, UserEnEchangeService} from '../../entities/user-en-echange';
import {GrhumService, Pays} from '../../entities/grhum';
import {Response} from '@angular/http';
import {CALENDAR_FR} from '../../shared/calendar/calendar.constants';

import {Campagne, CampagneService} from '../../entities/campagne';

@Component({
    selector: 'jhi-user-echange-dialog',
    templateUrl: './user-echange-dialog.component.html'
})
export class UserEchangeMgmtDialogComponent implements OnInit {

    user: UserEnEchange;
    languages: any[];
    authorities: any[];
    isSaving: Boolean;
    paysListe: Pays[];
    typeEtudiantEnumeration = TypeEtudiantEnumeration;
    fr: any;
    campagnes: Campagne[];

    constructor(
        public activeModal: NgbActiveModal,
        private languageHelper: JhiLanguageHelper,
        private jhiLanguageService: JhiLanguageService,
        private userService: UserEnEchangeService,
        private eventManager: EventManager,
        private grhumService: GrhumService,
        private alertService: AlertService,
        private campagneService: CampagneService
    ) {
    }

    ngOnInit() {
        this.fr = CALENDAR_FR;
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_SYSTEM', 'ROLE_ADMIN', 'ROLE_GEST', 'ROLE_REFERENT', 'ROLE_DELEGATE'];
        this.languageHelper.getAll().then((languages) => {
            this.languages = languages;
        });
        this.jhiLanguageService.setLocations(['user-echange']);
        this.grhumService.queryPays().subscribe(
            (res: Response) => {
                this.paysListe = res.json();
            }, (res: Response) => this.onError(res.json()));
        if (this.user.typeEtudiant == TypeEtudiantEnumeration.restrictionEmail) {

            this.campagneService.query({
                restrictionEmail: true
            }).subscribe(
                (res: Response) => {
                    this.campagnes = res.json();
                    if (this.user.campagne != null) {
                        this.user.campagne = this.campagnes.find((campagne) => campagne.id == this.user.campagne.id);
                    }
                },
                (res: Response) => this.onError(res.json())
            );
        }
    }

    clear() {
        this.activeModal.dismiss('cancel');
    }

    save() {
        this.isSaving = true;
        if (this.user.id != null) {
            this.userService.update(this.user).subscribe(response => this.onSaveSuccess(response), () => this.onSaveError());
        } else {
            // Remplissage des données avec contraintes "not null" dans la bdd
            if (this.user.typeEtudiant == TypeEtudiantEnumeration.restrictionEmail) {
                if (this.user.codePaysUniversite == null) {
                    this.user.codePaysUniversite = '100';
                }
                if (this.user.nomUniversiteOrigine == null) {
                    this.user.nomUniversiteOrigine = 'N/A';
                }
                if (this.user.typeEchange == null) {
                    this.user.typeEchange = 'N/A';
                }
            }
            this.userService.create(this.user).subscribe(response => this.onSaveSuccess(response), () => this.onSaveError());
        }
    }

    private onError(error) {
        this.alertService.error(error.error, error.message, null);
    }

    private onSaveSuccess(result) {
        this.eventManager.broadcast({name: 'userListModification', content: 'OK'});
        this.isSaving = false;
        this.activeModal.dismiss(result);
    }

    private onSaveError() {
        this.isSaving = false;
    }
}

@Component({
    selector: 'jhi-user-dialog',
    template: ''
})
export class UserEchangeDialogComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private userModalService: UserEchangeModalService
    ) {
    }

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            if (params['id']) {
                this.modalRef = this.userModalService.open(UserEchangeMgmtDialogComponent, params['id'], null);
            } else {
                if (params['typeEtudiant']) {
                    this.modalRef = this.userModalService.open(UserEchangeMgmtDialogComponent, null, params['typeEtudiant']);
                }
            }
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/admin/user-echange/user-echange-dialog.component.ts